import type { SignInLang } from './signInCopy'

/**
 * The words on #/collect/<code> — the scanned page. REC-49.
 *
 * NOT hubCopy.ts, for the same reason sign-in has its own table: there is no
 * person on this page, so there is no `me.locale`. The person holding the phone
 * may have no Conetec account at all (B21, the 40%-no-licence constraint). It
 * follows the BROWSER, like sign-in (pickSignInLang), with a visible switch.
 *
 * ── DRAFT ───────────────────────────────────────────────────────────────────
 *
 * The Spanish was written by an assistant on 27 Sep and has not been read by a
 * Spanish speaker. "Bodega" for the store room, tú throughout — sign-in's
 * register.
 */
export type CollectCopy = {
  checking: string
  readyTitle: string
  forWhom: (name: string) => string
  atRoom: (room: string) => string
  readyCheck: string
  noSignIn: string
  confirm: string
  confirming: string
  doneTitle: string
  doneBody: string
  alreadyTitle: string
  alreadyBody: string
  expiredTitle: string
  expiredBody: string
  notReadyTitle: string
  notReadyBody: string
  unknownTitle: string
  unknownBody: string
  errorTitle: string
  errorBody: string
  retry: string
}

export const COLLECT_COPY: Record<SignInLang, CollectCopy> = {
  en: {
    checking: 'Checking the code…',
    readyTitle: 'Hand this over',
    forWhom: (name) => `For ${name}`,
    atRoom: (room) => `From ${room}`,
    readyCheck: 'Check the name with the person in front of you, then confirm.',
    noSignIn: 'You do not need to sign in to do this.',
    confirm: 'Confirm it has been collected',
    confirming: 'Confirming…',
    doneTitle: 'Collected',
    doneBody: 'Done. The order is marked collected and there is nothing more to do.',
    alreadyTitle: 'Already collected',
    alreadyBody: 'This code has been used. There is nothing more to hand over.',
    expiredTitle: 'This code is no longer valid',
    expiredBody: 'The order was cancelled or its code expired, so there is nothing to hand over. Any stars have gone back to the person who ordered.',
    notReadyTitle: 'Not ready yet',
    notReadyBody: 'This order is not ready to hand over yet.',
    unknownTitle: 'We do not recognise this code',
    unknownBody: 'Check the whole code was scanned. If it is still not recognised, ask the person to open their order in OneConetec again.',
    errorTitle: 'Could not check this code',
    errorBody: 'Check the connection and try again.',
    retry: 'Try again',
  },
  es: {
    checking: 'Revisando el código…',
    readyTitle: 'Entrega esto',
    forWhom: (name) => `Para ${name}`,
    atRoom: (room) => `Desde ${room}`,
    readyCheck: 'Confirma el nombre con la persona que tienes enfrente y luego confirma la entrega.',
    noSignIn: 'No necesitas iniciar sesión para hacerlo.',
    confirm: 'Confirmar que se retiró',
    confirming: 'Confirmando…',
    doneTitle: 'Retirado',
    doneBody: 'Listo. El pedido quedó marcado como retirado y no hay nada más que hacer.',
    alreadyTitle: 'Ya fue retirado',
    alreadyBody: 'Este código ya se usó. No hay nada más que entregar.',
    expiredTitle: 'Este código ya no es válido',
    expiredBody: 'El pedido se canceló o su código venció, así que no hay nada que entregar. Las Stars volvieron a la persona que lo pidió.',
    notReadyTitle: 'Todavía no está listo',
    notReadyBody: 'Este pedido todavía no está listo para entregarse.',
    unknownTitle: 'No reconocemos este código',
    unknownBody: 'Revisa que se haya escaneado el código completo. Si sigue sin reconocerse, pide a la persona que vuelva a abrir su pedido en OneConetec.',
    errorTitle: 'No se pudo revisar este código',
    errorBody: 'Revisa la conexión y vuelve a intentarlo.',
    retry: 'Reintentar',
  },
}
